/* global gtag_report_conversion */
import React from "react";
import { FiPhone } from "react-icons/fi";
import "../styles/serviceAreaBanner.css";

export default function ServiceAreaBanner() {
  const cities = [
    "Budapest",
    "Érd",
    "Szentendre",
    "Vác",
    "Gödöllő",
    "Monor",
    "Cegléd",
    "Dunakeszi",
    "Budaörs",
    "Pilisvörösvár",
    "Pest megye (teljes terület)",
  ];

  return (
    <section
      className="service-banner pt-5"
      role="region"
      aria-labelledby="service-area-title"
      id="locations"
    >
      {/* Dark overlay */}
      <div className="service-banner__overlay" aria-hidden="true" />

      {/* Content */}
      <div className="service-banner__inner">
        <h2 id="service-area-title" className="service-banner__title pb-3">
          Mely településeken érhető el a szolgáltatás?
        </h2>

        <ul
          className="service-banner__cities pb-3"
          aria-label="Szolgáltatási területek"
        >
          {cities.map((city, idx) => (
            <li key={idx} className="service-banner__city">
              {city}
            </li>
          ))}
        </ul>

        <p className="service-banner__lead pb-3">
          Ne hagyd, hogy a lemerült akkumulátor megállítsa a napodat!
        </p>
        <p className="service-banner__cta pb-4">
          Hívd most szakembereinket, és indulj újra perceken belül!
        </p>

        <a
          href="tel:+36206282000"
          className="call-btn px-4 py-3 fs-4 d-inline-flex align-items-center"
          onClick={(e) => {
            try {
              if (typeof gtag_report_conversion === "function") {
                gtag_report_conversion("tel:+36206282000");
              }
            } catch (err) {
              console.error("gtag_report_conversion error:", err);
            }
          }}
        >
          <FiPhone className="me-2" />
          +36 20 628 2000
        </a>
      </div>
    </section>
  );
}
